<template>
  <div>
    <!-- PerfilView -->
  </div>
</template>

<script>
export default {
  name: 'PerfilView'
}
</script>



// WEBPACK FOOTER //
// src/views/clientes/PerfilView.vue